import React, { Fragment } from 'react';

// Components

import SummaryItem from '../SummaryItem';

// Utils

import { getDateDifference } from '@utils/dates/date.utils';

// Constants

import { getOptionsForHardcodedState } from '@constants/ssap/hhmTypes/dropdownOptions';

const FosterCareInfo = props => {
    
    const {
        ageWhenLeftFosterCare,
        applyingForCoverageIndicator,
        dateOfBirth,
        everInFosterCareIndicator,
        gettingHealthCareThroughStateMedicaidIndicator,
        fosterCareState,
        idx,
        serverDate
    } = props;

    const age = getDateDifference(serverDate, dateOfBirth, 'year');

    const getStateAbbr = state => {
        const [ stateAbbr ] = state ? getOptionsForHardcodedState(state) : [{}];
        return stateAbbr.state;
    };
    
    if(!(applyingForCoverageIndicator && age >= 18 && age <= 25)) {
        return null;
    }
    
    return (
        <Fragment>
            <SummaryItem
                textCode = 'common.foster_care'
                value = { everInFosterCareIndicator }
                desc = {
                    [
                        [
                            `taxHousehold.householdMember[${ idx }].specialCircumstances.everInFosterCareIndicator`
                        ]
                    ]
                }
            />
            {
                everInFosterCareIndicator &&

                <Fragment>
                    <SummaryItem
                        textCode = 'common.foster_care_system_state'
                        value = { getStateAbbr(fosterCareState) }
                        ignoreIntl
                        desc = {
                            [
                                [
                                    `taxHousehold.householdMember[${ idx }].specialCircumstances.fosterCareState`,
                                    getStateAbbr
                                ]
                            ]
                        }
                    />
                    <SummaryItem
                        textCode = 'common.health_medicaid'
                        value = { gettingHealthCareThroughStateMedicaidIndicator }
                        desc = {
                            [
                                [
                                    `taxHousehold.householdMember[${ idx }].specialCircumstances.gettingHealthCareThroughStateMedicaidIndicator`
                                ]
                            ]
                        }
                    />
                    <SummaryItem
                        textCode = 'common.foster_care_age'
                        value = { ageWhenLeftFosterCare }
                        ignoreIntl
                        desc = {
                            [
                                [
                                    `taxHousehold.householdMember[${ idx }].specialCircumstances.ageWhenLeftFosterCare`
                                ]
                            ]
                        }
                    />
                </Fragment>
            }
        </Fragment>
    );
};

export default FosterCareInfo;